var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 0C0.307804 0 0 0.307804 0 0.6875C0 1.0672 0.307804 1.375 0.6875 1.375H1.95771C2.11345 1.375 2.24973 1.4797 2.28986 1.63018L4.63445 10.4224C3.15497 10.8061 2.0625 12.1505 2.0625 13.75C2.0625 14.1297 2.3703 14.4375 2.75 14.4375H17.1875C17.5672 14.4375 17.875 14.1297 17.875 13.75C17.875 13.3703 17.5672 13.0625 17.1875 13.0625H3.55486C3.838 12.2614 4.60197 11.6875 5.5 11.6875H15.7834C16.0463 11.6875 16.2862 11.5375 16.4014 11.3012C17.442 9.16577 18.3501 6.95386 19.115 4.67615C19.1758 4.49494 19.1585 4.29657 19.0671 4.12866C18.9757 3.96075 18.8186 3.83847 18.6334 3.79117C14.2134 2.66238 9.58249 2.0625 4.8125 2.0625C4.48449 2.0625 4.15713 2.06534 3.83046 2.07099L3.61843 1.27589C3.41779 0.523497 2.73639 0 1.95771 0H0.6875Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 16.5C2.0625 15.7406 2.67811 15.125 3.4375 15.125C4.19689 15.125 4.8125 15.7406 4.8125 16.5C4.8125 17.2594 4.19689 17.875 3.4375 17.875C2.67811 17.875 2.0625 17.2594 2.0625 16.5Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.5C13.75 15.7406 14.3656 15.125 15.125 15.125C15.8844 15.125 16.5 15.7406 16.5 16.5C16.5 17.2594 15.8844 17.875 15.125 17.875C14.3656 17.875 13.75 17.2594 13.75 16.5Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerce);
export default __webpack_public_path__ + "static/media/commerce.b10e5add26f54a0554ec5f3f7678333c.svg";
export { ForwardRef as ReactComponent };